import { ui } from "@/strings";

/**
 * MarkeerooBrand component - renders "Markeroo" in the branded font.
 *
 * IMPORTANT: The `font-brand` CSS class (which uses the rounded brand font)
 * should ONLY be used within this component. Never use `font-brand` directly
 * elsewhere in the codebase - always import and use this component instead.
 *
 * This ensures consistent branding and makes it easy to update the styling
 * in one place if needed.
 */
export function MarkeerooBrand({ className = "" }: { className?: string }) {
  return (
    <span className={`font-brand font-bold text-text-theme-secondary ${className}`}>
      {ui.headers.appName}
    </span>
  );
}
